import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

export const menuGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const store$ = inject(Store);

  return store$
    .select((store) => store.userState.user)
    .pipe(
      // otherwise, something went wrong
      switchMap((data) => {
        const index = data.menus.findIndex((x) => x.route === route.url[0].path);
        if (index > -1) {
          return of(true);
        } else {
          void router.navigate(['/forbidden']);

          return of(false);
        }
      }),
      catchError(() => of(false))
    );
};
